'use client';
import { Box } from '@mui/material';
import Video from '../../gallery/Video';
import { MarkdownVideo } from '@jd/platform-config/types';
import { DeepNullToUndefined } from '@jd/client/utils/unnulable';

const BlockVideo = ({
  video,
  autoPlay,
  loop,
  controls,
  maxWidth,
  poster,
  theme,
}: DeepNullToUndefined<MarkdownVideo>) => {
  if (!video || typeof video === 'string' || !video.muxPlaybackId) return null;

  return (
    <Box
      sx={{ my: 2, maxWidth: `${maxWidth ?? 100}%`, mx: 'auto' }}
      className={'tb-vidoe-container'}
    >
      <Video
        playbackId={video.muxPlaybackId}
        aspectRatio={video.aspectRatio ?? 16 / 9}
        withAutoPlay={autoPlay ?? false}
        loop={loop ?? false}
        controls={controls ?? false}
        poster={poster}
        theme={theme}
      />
    </Box>
  );
};

export default BlockVideo;
